import { useIntl } from '@/intl'
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common'

const emptyTranslationDefaultMessage = ' '

export function useMetaTranslation(
  translationTag: string,
  translationValues: Record<string, string> | undefined,
  metadataName: string,
) {
  const intl = useIntl()
  const logger = useCommonDependency('logger')
  const value = intl.formatMessage(
    { id: translationTag, defaultMessage: emptyTranslationDefaultMessage },
    translationValues,
  )

  if (value === emptyTranslationDefaultMessage) {
    logger.logError(new Error(`Missing translation for meta ${metadataName} with tag: ${translationTag}`))
  }

  return value
}
